<template>
  <!-- Quick links into common webmail, reused on the verify-email and reset-password confirmations.
       Where the provider supports it via URL these open a spam-inclusive view (Gmail all-mail search
       incl. Spam/Trash; Outlook Junk folder); Yahoo & Apple Mail open the inbox. Open in a new tab. -->
  <div class="mail-providers">
    <a
      v-for="p in mailProviders"
      :key="p.label"
      class="btn mail-provider-btn"
      :href="p.url"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img class="mail-provider-logo" :src="p.icon" :alt="`${p.label} logo`" />
      <span>{{ p.label }}</span>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import gmailIcon from '../../images/mail/gmail.svg';
import appleMailIcon from '../../images/mail/apple-mail.svg';
import outlookIcon from '../../images/mail/outlook.svg';
import yahooIcon from '../../images/mail/yahoo.svg';

export default defineComponent({
  name: 'OpenMailboxButtons',
  data() {
    return {
      mailProviders: [
        { label: 'Open Gmail', icon: gmailIcon, url: 'https://mail.google.com/mail/u/0/#search/in%3Aanywhere+hiiker' },
        { label: 'Open Apple Mail', icon: appleMailIcon, url: 'https://www.icloud.com/mail' },
        { label: 'Open Outlook', icon: outlookIcon, url: 'https://outlook.live.com/mail/0/junkemail' },
        { label: 'Open Yahoo', icon: yahooIcon, url: 'https://mail.yahoo.com' },
      ],
    };
  },
});
</script>

<style scoped>
.mail-providers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem;
}
.mail-provider-btn {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.6rem 0.75rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
}
.mail-provider-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.mail-provider-logo {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
@media (max-width: 400px) {
  .mail-providers {
    grid-template-columns: 1fr;
  }
}
</style>
